import {ConfigsProperties} from "./index";


const config: ConfigsProperties = {
    BASE_API: 'http://20.185.180.8:8100/',
    SHA1_SALT: '6sJJnUiq',
    QINIU_HOST: 'http://drptest.erp-ax.cn/',
}

export default config
